import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { get } from 'lodash';
import { getDealerAccessSchema, uiSchema } from './Schema';
import './UserEditor.scss';
import transformErrors from './utils';
import LoadingOverlay from '../LoadingOverlay';

export default class AccessEditor extends PureComponent {
  constructor(props) {
    super(props);
    const { user, dealers } = this.props;
    const userDealers = this.getUsersDealers(user, dealers);
    this.state = {
      formData: {
        ...user,
        dealers: userDealers,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dealers !== this.props.dealers) {
      const { user, dealers } = this.props;
      const userDealers = this.getUsersDealers(user, dealers);
      this.setState({ formData: { ...user, dealers: userDealers } });
    }
  }

  onSubmit = ({ formData }) => {
    const { dealers } = formData;
    const dealersForApiRequest = dealers.map(
      ({ id, ...userDealerWithoutDealerId }) => ({
        ...userDealerWithoutDealerId,
        dealer_id: id,
      }),
    );

    this.props.onSave(dealersForApiRequest);
  };

  getUsersDealers = (user, dealers) => {
    const dealerHash = {};
    // Create a hashmap of dealer Ids to know what the unique dealer Ids are
    dealers.forEach(({ id }) => {
      dealerHash[id] = 1;
    });
    const userDealers = [];
    // Filter user dealers to show only dealers that exist
    get(user, 'Dealers', []).forEach(d => {
      if (dealerHash[d.id]) {
        userDealers.push({
          id: d.id,
          crmUserId: d.UserDealer.crmUserId,
          fniUserId: d.UserDealer.fniUserId,
        });
      }
    });

    return userDealers;
  };

  render() {
    const { fetching, dealers } = this.props;
    const schema = getDealerAccessSchema(dealers);

    return (
      <div className="user-list-container">
        <LoadingOverlay active={fetching}>
          <Form
            schema={schema}
            uiSchema={uiSchema}
            formData={this.state.formData}
            transformErrors={transformErrors}
            onSubmit={this.onSubmit}
            enctype="multipart/form-data"
          >
            <Button
              bsClass="btn btn-primary btn-large"
              disabled={fetching}
              type="submit"
            >
              Save
            </Button>
          </Form>
        </LoadingOverlay>
      </div>
    );
  }
}

AccessEditor.propTypes = {
  fetching: PropTypes.bool,
  user: PropTypes.object,
  dealers: PropTypes.array,
  onSave: PropTypes.func,
};
